import React from "react";
import { EmailOption } from "../../types/budgeting";
import { Plus, Trash } from "lucide-react";

interface EmailOptionsProps {
  emailOptions: EmailOption[];
  handleEmailChange: (index: number, value: string) => void;
  handleAddEmail: () => void;
  removeEmail: (index: number) => void;
  isViewMode?: boolean;
}

const EmailOptions: React.FC<EmailOptionsProps> = ({
  emailOptions,
  handleEmailChange,
  handleAddEmail,
  removeEmail,
  isViewMode = false,
}) => {
  return (
    <div className="p-6 border-b border-gray-200">
      <div className="bg-white shadow-md border border-gray-200 rounded-md p-6">
        <h3 className="text-md font-semibold text-gray-700 mb-4">
          Send the budget as an email?
        </h3>
        {emailOptions.length === 0 && !isViewMode && (
          <div className="mb-4">
            <button
              onClick={handleAddEmail}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors"
            >
              <Plus size={18} /> Add Email
            </button>
          </div>
        )}
        {emailOptions.map((email, index) => (
          <div key={index} className="flex items-center gap-2 mb-2">
            <input
              type="email"
              placeholder="Enter email address"
              className={`w-full border ${
                email.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.email) ? "border-red-500" : "border-gray-300"
              } rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm ${
                isViewMode ? "bg-gray-100" : ""
              }`}
              value={email.email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
              readOnly={isViewMode}
              disabled={isViewMode}
            />
            {!isViewMode && (
              index === emailOptions.length - 1 ? (
                <button
                  onClick={handleAddEmail}
                  className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-1 w-8 h-8 flex items-center justify-center shadow-sm transition-colors"
                >
                  <Plus size={18} />
                </button>
              ) : (
                <button
                  onClick={() => removeEmail(index)}
                  className="bg-red-500 hover:bg-red-600 text-white rounded-full p-1 w-8 h-8 flex items-center justify-center shadow-sm transition-colors"
                >
                  <Trash size={18} />
                </button>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailOptions;